import { render, staticRenderFns } from "./StrabaneIncomingOrders.vue?vue&type=template&id=52ad409c"
import script from "./StrabaneIncomingOrders.vue?vue&type=script&lang=js"
export * from "./StrabaneIncomingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports